<template>
    <div>
        <main>
            <main-header :title='title' :fullname="fullName" :user-id="currentUserId"
                         :searchBoxPlaceholder='placeholder' :show-sandwich-menu="isSideBarVisible"></main-header>
            <main-sidebar v-if="isSideBarVisible"  :menuItems="menuItems" :selectedItem="selectedItem"
                          @quickcreate-clicked="showHelpDeskCreationForm"></main-sidebar>
            <section class="content" :class="{'content--full': contentFull}">
                <div class="content__inner">
                    <slot name="content"></slot>
                </div>
                <div ref="modalContainer"></div>
            </section>
            <main-footer v-if="showFooter"></main-footer>
        </main>
    </div>
</template>

<script>
    import MainLayout from '@/layout/Main'
    import Header from '@/layout/Header'
    import SideBar from '@/components/SideBar'
    import QuickCreateForm from "@/components/QuickCreateForm";
    import { mapGetters } from 'vuex'
    import cookies from 'vue-js-cookie';
    import AppHelper from "../helper";

    export default {
        extends: MainLayout,

        data() {
            return {
                contentFull: false,
                submitInProgress: false,
                placeholder: this.$t('LBL_SEARCH_PLACEHOLDER'),
            }
        },

        components: {
            'main-header': Header,
            'main-sidebar': SideBar
        },

        computed: {
            ...mapGetters({
                menuItems: 'getMenuItems'
            }),

            title() {
                return this.$store.getters.getStructure.company_info.name
            },

            fullName() {
                let userInfo = this.$store.getters.getStructure.user_info
                return userInfo.firstname + ' ' + userInfo.lastname
            },

            selectedItem() {
                return this.$route.params.module
            },

            currentUserId() {
                return cookies.get('crmid');
            },

            isSideBarVisible() {
                let visibilityStatus = true
                let access = this.$store.getters.getStructure.access

                if(access && !access.client_portal && !access.invoices){
                    visibilityStatus = false
                }

                this.contentFull = !visibilityStatus
                return visibilityStatus
            }
        },

        methods: {
            async showHelpDeskCreationForm() {
                let context = this;
                let quickCreateForm = this.getComponentInstance(QuickCreateForm, {
                    propsData: {
                        mainFields:  this.transformHelpDeskQuickCreateFields(this.$store.getters.getQuickCreateFields('HelpDesk')),
                        title: this.$t('LBL_CREATE_A_TICKET'),
                        titleIcon : 'zmdi-plus',
                        submitButtonLabel: this.$t('LBL_SUBMIT_TICKET'),
                        module: this.module
                    }
                })

                quickCreateForm.$mount()

                quickCreateForm.$on('form-submited', (data) => {
                    if(this.submitInProgress){
                        return
                    }

                    quickCreateForm.$props.showLoader = true
                    this.submitInProgress = true

                    this.createHelpDesk(data).then((recordId) => {
                        if(!recordId){
                            AppHelper.notify(this.$t('LBL_ERROR_RECORD_CREATION'), 'warning')
                        }else{
                            quickCreateForm.close()
                            this.$router.push({ name: 'Detail',
                                params: {view: 'DetailView', module: 'HelpDesk', record: recordId.toString()}})
                        }

                        quickCreateForm.$props.showLoader = false
                        this.submitInProgress = false
                    })
                })

                this.$refs.modalContainer.appendChild(quickCreateForm.$el)
            },

            transformHelpDeskQuickCreateFields(fields) {
                let fieldsOrder = ['ticket_title', 'ticketcategories', 'ticketpriorities', 'description']
                let transformedFields = []

                fieldsOrder.forEach((key) => {
                    let field = fields[key]
                    field.value = field.defaultValue

                    if(field.name === 'ticketcategories'){
                        field.label = this.$t('LBL_HELPDESK_TYPE')
                        field.value = 'Anomaly'
                    }else if(field.name === 'ticketpriorities' && !field.value){
                        field.value = 'Normal'
                    }

                    field.mandatory = true
                    field.isFloat = false
                    transformedFields.push(field)
                })

                transformedFields.push({
                    name: 'attachments',
                    label: this.$t('LBL_ATTACHED_FILES'),
                    type: 'attachment',
                    editable: true
                })

                return transformedFields
            },

            async createHelpDesk(data) {
                data.formData['contact_id'] = this.$store.getters.getStructure.user_info.id
                let response = await Api.save('HelpDesk', Object.assign(data.formData,
                    {'parent_id': this.$store.getters.getStructure.user_info.account_id, 'ticketstatus': 'Open'}))

                if(!response.success || !response.result.record_id){
                    return false;
                }

                if(data.attachments){
                    for(let key in data.attachments){
                        let attachment = data.attachments[key]
                        await Api.save('Documents', {notes_title: attachment.name, filelocationtype: 'I', filestatus: 1},
                            response.result.record_id, {'filename': attachment})
                    }
                }

                return response.result.record_id
            }
        }
    }

</script>
<style lang="scss">@import "@/assets/scss/layout/_boxed.scss";</style>